<div fxLayout="column" class="w-100">
    <mat-form-field *ngIf="filteredGroups | async; let source; else: loading" fxFlex="0 1 100%" class="mb-4 chip-list">
        <mat-chip-list class="group-chips" #chipList aria-label="Add Groups*">
            <mat-chip
                *ngFor="let group of selection"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(group)"
            >
                {{ group.name }}
                <mat-icon matChipRemove *ngIf="removable"> cancel </mat-icon>
            </mat-chip>
            <input
                #groupInput
                [placeholder]="placeholder"
                i18n-placeholder
                [formControl]="groupCtrl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event, source)"
            />
        </mat-chip-list>
        <mat-autocomplete
            #auto="matAutocomplete"
            (closed)="optionClosed()"
            (optionActivated)="optionActivated($event)"
            (optionSelected)="onSelected($event)"
        >
            <mat-option *ngFor="let group of source" [value]="group" class="group-options">
                {{ group.name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <div
        *ngIf="!hasAvailableGroups?.value && noGroupsAvailableMessage"
        fxLayout="row"
        fxLayoutAlign="start center"
        class="no-groups-available"
    >
        <span>{{ noGroupsAvailableMessage }}</span>
        <mat-icon>info</mat-icon>
    </div>
</div>
<ng-template #loading>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
